import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initAnalytics, trackPageView } from "helpers/analytics.js";

/**
 * Initialises GA4 once and reports a page_view on every client-side route
 * change. Rendered inside <Router> so useLocation is available. Renders nothing.
 */
const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    initAnalytics();
  }, []);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
};

export default AnalyticsTracker;
